import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import FGBLabel from '../../Elements/FGBLabel/FGBLabel';
import ReactRouterLink from '../../Groups/ReactRouterLink'; // eslint-disable-line import/no-named-as-default
import { ContentSnipper } from '../../Wrappers/ContentSnipper/ContentSnipper';
import './DiscussionComponent.scss';

export const charactersPerMode = {
    feed: {
        sentences: 2,
        characters: 240,
    },
    topic: {
        sentences: 2,
        characters: 240,
    },
    full: {
        sentences: 0,
        characters: 0,
    },
};

const MorePrompt = ({ hasMoreContent }) =>
    hasMoreContent ? <span className="more">More...</span> : null;

MorePrompt.propTypes = {
    hasMoreContent: PropTypes.bool,
};

MorePrompt.defaultProps = {
    hasMoreContent: false,
};

export default class DiscussionComponent extends React.PureComponent {
    renderLabel = (label, mode) => {
        if (label && label.length && mode !== 'topic') {
            return <FGBLabel>{label}</FGBLabel>;
        }

        return null;
    };

    renderDiscussionBody = (
        discussionUrl,
        title,
        description,
        mode,
        location
    ) => {
        const hasMoreContent = description && description.slice(-3) === '...';

        return (
            <PageConsumer>
                {(context) => {
                    const discussionBody =
                        mode === 'full' ? (
                            <div className="title">{title}</div>
                        ) : (
                            <div className="title">
                                <span className="underline-hover">
                                    <ContentSnipper
                                        sentences={
                                            charactersPerMode[mode].sentences
                                        }
                                        characters={
                                            charactersPerMode[mode].characters
                                        }
                                        truncateWithLink
                                    >
                                        {title}
                                    </ContentSnipper>
                                </span>
                                {title &&
                                title.length >
                                    charactersPerMode[mode].characters ? (
                                    <span className="more">More...</span>
                                ) : null}
                            </div>
                        );

                    if (
                        location !== 'groupFeed' ||
                        !context.pageProps.frontendRouting
                    ) {
                        return (
                            <a href={discussionUrl} className="discussion-link">
                                {discussionBody}
                                {description && mode !== 'topic' && (
                                    <div className="description">
                                        {description}
                                        <MorePrompt
                                            hasMoreContent={hasMoreContent}
                                        />
                                    </div>
                                )}
                            </a>
                        );
                    }

                    return (
                        <ReactRouterLink
                            to={discussionUrl}
                            linkText={discussionUrl}
                            buildFullPath={false}
                        >
                            <div className="discussion-link">
                                {discussionBody}
                                {description && mode !== 'topic' && (
                                    <div className="description">
                                        {description}
                                        <MorePrompt
                                            hasMoreContent={hasMoreContent}
                                        />
                                    </div>
                                )}
                            </div>
                        </ReactRouterLink>
                    );
                }}
            </PageConsumer>
        );
    };

    render() {
        const {
            discussionUrl,
            className,
            hash,
            mode,
            label,
            title,
            description,
            location,
        } = this.props;
        const trimmedTitle = title.trim();
        return (
            <div
                className={`component-Community-DiscussionComponent ${className} ${hash} ${mode}`}
            >
                {this.renderLabel(label, mode)}
                {this.renderDiscussionBody(
                    discussionUrl,
                    trimmedTitle,
                    description,
                    mode,
                    location
                )}
            </div>
        );
    }
}

DiscussionComponent.propTypes = {
    discussionUrl: PropTypes.string.isRequired,
    className: PropTypes.string,
    hash: PropTypes.string.isRequired,
    mode: PropTypes.string.isRequired,
    label: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    location: PropTypes.string,
};

DiscussionComponent.defaultProps = {
    className: '',
    label: null,
    location: null,
};
